var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.isNavbarVisible)?_c('navbar-component'):_vm._e(),_c('router-view'),_c('loading-screen-component'),(_vm.isPopupVisible)?_c('popup-component'):_vm._e(),(_vm.isFooterVisible)?_c('footer-component'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }